import { Box } from '@mui/material';
import Container from '@mui/material/Container';
import React from 'react';

import {
  FullPageSpinnerRingInnerStyles,
  FullPageSpinnerRingStyles,
} from './fullPageSpinner.styles.ts';

export const FullPageSpinner: React.FC = () => {
  return (
    <Container>
      <Box sx={FullPageSpinnerRingStyles}>
        <Box sx={FullPageSpinnerRingInnerStyles}></Box>
      </Box>
    </Container>
  );
};
